/* eslint-disable */
import React from 'react';
import Slider from 'react-slick';
import { messages } from '../../common/messages';

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <img onClick={onClick} src='../../assets/img/right-arrow.svg' alt='arrow image' />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        fontSize: '60px',
        right: '80px',
        zIndex: '15',
        height: '20px',
        width: '40px',
        opacity: '1',
      }}
      onClick={onClick}
    >
      <img onClick={onClick} src='../../assets/img/left-arrow.svg' alt='arrow left image' />
    </div>
  );
}

function VideoListSlider({
  videos,
  isUserSubscribed,
  hasPlusAccess = false,
  premiumModalToggle,
  redirectToPlaylist,
}) {
  let count = 0;
  return (
    <div>
      <Slider {...settings}>
        {videos.map((item, index) => {
          // Per-item substitution for `isUserSubscribed`. Non-webinar items:
          // identical value. Webinars: gated on Plus tier.
          const isSubscribedForItem = item && item.media_type === 'webinar' ? !!hasPlusAccess : !!isUserSubscribed
          return (
            <div key={index}>
                {!isSubscribedForItem ? (
                item.free ? (
                  <div className='video-type-free'>{messages.FREE}</div>
                ) : (
                  <div className='video-type-primum'>{messages.PREMIUM}</div>
                )
              ) : (
                <div />
              )}
              {!item.url_id_qq || item.url_id_qq === 'null' ? (
                <img
                  alt='youtube thumbnail image'
                  width='100%'
                  src={`https://img.youtube.com/vi/${item.url_id}/mqdefault.jpg`}
                  value={index}
                  onClick={() =>
                    isSubscribedForItem || item.free
                      ? redirectToPlaylist(item)
                      : premiumModalToggle()
                  }
                  className='pointer_class slider_row'
                />
              ) : (
                <img
                  alt='flowplayer thumbnail image'
                  width='100%'
                  src={
                    item.posterImage && item.posterImage !== 'null'
                      ? item.posterImage
                      : `https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-${
                          item.url_id_qq
                        }-1.jpg`
                  }
                  onError={({ currentTarget }) => {
                    if (!count++) {
                      // Added condition because of infinite loop, this will once only
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = `
                      https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-${
                        item.url_id_qq
                      }-1_2.jpg`;
                    }
                  }}
                  value={index}
                  onClick={() =>
                    isSubscribedForItem || item.free
                      ? redirectToPlaylist(item)
                      : premiumModalToggle()
                  }
                  className='pointer_class slider_row'
                />
              )}
              <strong style={{ padding: '10px' }}> {item.title}</strong>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default VideoListSlider;



// WEBPACK FOOTER //
// ./src/Components-2025/Videos/VideoListSlider.jsx